<template>
  <div id="calculator">

  </div>
</template>

<script>
export default {
  name: "Calculator", // 计算器
  components: {}
};
</script>

<style lang="scss" scoped>
#calculator {
  margin-top: 10px;
  height: 135px;
  width: 100%;
  background: #9e9e9e;
}
</style>
